(function () {
  var ACCOUNT_ID = "XSYZJZ";
  var SUBSCRIBE_URL =
    "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=" +
    ACCOUNT_ID;

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function overlay() {
    return qs("[data-klaviyo-bis-overlay]");
  }

  function setStatus(message, isError) {
    var el = qs("[data-klaviyo-bis-status]");
    if (!el) return;
    el.hidden = !message;
    el.textContent = message || "";
    el.classList.toggle("is-error", !!isError);
  }

  function open(opts) {
    var node = overlay();
    if (!node || !opts || !opts.variantId) return;
    node.hidden = false;
    node.setAttribute("aria-hidden", "false");
    node.dataset.variantId = String(opts.variantId);
    node.dataset.productId = opts.productId ? String(opts.productId) : "";
    var title = qs("[data-klaviyo-bis-title]");
    if (title) {
      title.textContent = opts.productName || "This product";
    }
    setStatus("", false);
    var form = qs("[data-klaviyo-bis-form]");
    if (form) form.reset();
    var email = qs("[data-klaviyo-bis-email]");
    if (email) email.focus();
    document.documentElement.classList.add("klaviyo-bis-open");
  }

  function close() {
    var node = overlay();
    if (!node) return;
    node.hidden = true;
    node.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("klaviyo-bis-open");
  }

  function subscribe(email, variantId) {
    var payload = {
      data: {
        type: "back-in-stock-subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: { email: email },
            },
          },
          channels: ["EMAIL"],
        },
        relationships: {
          variant: {
            data: {
              type: "catalog-variant",
              id: "$shopify:::$default:::" + String(variantId),
            },
          },
        },
      },
    };

    return fetch(SUBSCRIBE_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        revision: "2024-10-15",
      },
      body: JSON.stringify(payload),
    }).then(function (res) {
      if (res.status === 202) return {};
      return res
        .json()
        .catch(function () {
          return {};
        })
        .then(function (data) {
          var err =
            data &&
            data.errors &&
            data.errors[0] &&
            (data.errors[0].detail || data.errors[0].title);
          throw new Error(err || "Request failed");
        });
    });
  }

  function bindOverlay() {
    var node = overlay();
    if (!node || node.dataset.bound) return;
    node.dataset.bound = "1";

    node.addEventListener("click", function (evt) {
      if (evt.target === node || evt.target.closest("[data-klaviyo-bis-close]")) {
        close();
      }
    });

    document.addEventListener("keydown", function (evt) {
      if (evt.key === "Escape" && !node.hidden) close();
    });

    var form = qs("[data-klaviyo-bis-form]");
    if (!form) return;
    form.addEventListener("submit", function (evt) {
      evt.preventDefault();
      var emailInput = qs("[data-klaviyo-bis-email]");
      var email = emailInput && emailInput.value ? emailInput.value.trim() : "";
      var variantId = node.dataset.variantId;
      if (!email || !variantId) {
        setStatus("Enter a valid email address.", true);
        return;
      }
      var submitBtn = qs("[data-klaviyo-bis-submit]");
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = "Sending…";
      }
      subscribe(email, variantId)
        .then(function () {
          setStatus("You're in! We'll let you know when it's back.", false);
          setTimeout(close, 1800);
        })
        .catch(function (err) {
          var message =
            err && err.message && err.message !== "Request failed"
              ? err.message
              : "Something went wrong. Please try again.";
          setStatus(message, true);
        })
        .finally(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = "Notify me when available";
          }
        });
    });
  }

  function linkedProductForm() {
    var marker = qs("[data-klaviyo-bis-linked]");
    if (!marker) return null;
    return marker.closest("form") || marker;
  }

  function syncLinkedProductButton(detail) {
    var form = linkedProductForm();
    if (!form) return;
    var btn = form.querySelector("[data-add-to-cart]");
    var text = form.querySelector("[data-add-to-cart-text]");
    if (!btn) return;
    var variant = detail && detail.variant;
    if (variant && variant.available === false) {
      btn.disabled = false;
      btn.classList.remove("disabled");
      btn.classList.add("is-bis");
      btn.setAttribute("data-bis-active", "true");
      if (text) text.textContent = "Notify Me When Available";
      btn.dataset.bisVariantId = String(variant.id);
      if (variant.product_id) {
        btn.dataset.bisProductId = String(variant.product_id);
      }
    } else {
      btn.classList.remove("is-bis");
      btn.removeAttribute("data-bis-active");
      delete btn.dataset.bisVariantId;
      delete btn.dataset.bisProductId;
    }
  }

  function bindLinkedProductForm() {
    var form = linkedProductForm();
    if (!form) return;

    document.addEventListener("variant:change", function (evt) {
      requestAnimationFrame(function () {
        syncLinkedProductButton(evt.detail || {});
      });
    });

    form.addEventListener(
      "click",
      function (evt) {
        var btn = evt.target.closest("[data-bis-active]");
        if (!btn) return;
        evt.preventDefault();
        evt.stopPropagation();
        var marker = qs("[data-klaviyo-bis-linked]");
        open({
          variantId: btn.dataset.bisVariantId,
          productId: btn.dataset.bisProductId,
          productName:
            (marker && marker.getAttribute("data-bis-product-name")) || "",
        });
      },
      true
    );

    var atc = form.querySelector("[data-add-to-cart]");
    if (atc && atc.disabled) {
      var select = form.querySelector("[data-product-select], [name='id']");
      var marker = qs("[data-klaviyo-bis-linked]");
      syncLinkedProductButton({
        variant: {
          id: select && select.value,
          available: false,
          product_id: marker && marker.getAttribute("data-bis-product-id"),
        },
      });
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    bindOverlay();
    bindLinkedProductForm();
  });

  window.FluxKlaviyoBis = {
    open: open,
    close: close,
  };
})();
